import { render, staticRenderFns } from "./Join.vue?vue&type=template&id=1f05cc72&scoped=true&"
import script from "./Join.vue?vue&type=script&lang=ts&"
export * from "./Join.vue?vue&type=script&lang=ts&"
import style0 from "./Join.vue?vue&type=style&index=0&id=1f05cc72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f05cc72",
  null
  
)

export default component.exports